import Vue from 'vue'
import VueRouter from 'vue-router'
import routes from './routes' // routes 파일에서 경로를 가져옴

// Router push 에러 방지
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err)
}

Vue.use(VueRouter)

const router = new VueRouter({
  routes,
  mode: 'history', // History 모드 활성화
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition // 이전 스크롤 위치로 이동
    }
    if (to.hash) {
      return {
        selector: to.hash, // 특정 해시로 스크롤
      }
    }
    return { x: 0, y: 0 } // 기본 위치로 스크롤
  },
})

// 라우트 변경 후 페이지 상단으로 이동
router.afterEach(() => {
  window.scrollTo(0, 0)
})

export default router
